



























































































































import { Component, Vue, Mixins, Prop } from 'vue-property-decorator';
import UserMixin from '@/mixins/UserMixin';
import EditViewMixin from '@/mixins/EditViewMixin';
import DeviceViewMixin from '@/mixins/DeviceViewMixin';
import PromiseLoaderMixin from '@/mixins/PromiseLoaderMixin';

import TopMenu from '@/components/TopMenu.vue';
import FooterMenu from '@/components/FooterMenu.vue';
import RelayButton from '@/components/RelayButton.vue';
import IconPicker from '@/components/IconPicker.vue';
import SoftwareUpdateAvailableIcon from '@/components/SoftwareUpdateAvailableIcon.vue';

import { State, Getter, Action, Mutation } from 'vuex-class';
import { IRelay } from '@/store/views/relaysView/types';
import { ViewsState } from '@/store/views/types';
import { IButtonsButtonWithRelay } from '@/store/views/buttonsView/types';

@Component({
    components: {
        TopMenu,
        FooterMenu,
        RelayButton,
        IconPicker,
        SoftwareUpdateAvailableIcon,
    },
})
export default class Buttons extends Mixins(UserMixin, EditViewMixin, DeviceViewMixin, PromiseLoaderMixin) {

    public loading: boolean = true;
    public newDeviceName: string = '';

    public get buttons(): IButtonsButtonWithRelay[] {
        return this.getButtons && this.deviceNumber && this.getButtons(this.deviceNumber, this.isEditing) || [];
    }

    // Vuex stuff
    @Getter('buttonsView/buttons')
    private getButtons?: (deviceNumber: string, includeHidden: boolean) => IButtonsButtonWithRelay[];
    @Action('devices/setDeviceName')
    private setDeviceName?: (args: {deviceNumber: string, name: string}) => Promise<any>;
    @Mutation('buttonsView/setVisibility')
    private buttonSetVisibility?: (args: {deviceNumber: string, index: number, hidden: boolean}) => void;
    @Mutation('buttonsView/moveUp')
    private buttonMoveUp?: (args: {deviceNumber: string, index: number}) => void;
    @Mutation('buttonsView/moveDown')
    private buttonMoveDown?: (args: {deviceNumber: string, index: number}) => void;
    @Mutation('relaysView/setName')
    private relaysSetName?: (args: {deviceNumber: string, relayNumber: number, name: string }) => void;
    @Mutation('relaysView/setMode')
    private relaysSetMode?: (args: {deviceNumber: string, relayNumber: number, mode: string }) => void;
    @Mutation('relaysView/setIcon')
    private relaysSetIcon?: (args: {deviceNumber: string, relayNumber: number, icon: string }) => void;


    public startEditing(): void {
        this.isEditing = true;
        this.newDeviceName = this.deviceInfo && this.deviceInfo.name || '';
    }
    public async saveEditing(): Promise<any> {
        this.loading = true;
        try {
            const promises: Array<Promise<any>> = [];

            if (this.setDeviceName && this.deviceNumber && this.newDeviceName
            && this.deviceInfo && this.newDeviceName !== this.deviceInfo.name) {

                await this.setDeviceName({deviceNumber: this.deviceNumber, name: this.newDeviceName});
            }
            await this.$store.dispatch('relaysView/pushToViews', {deviceNumber: this.deviceNumber});
            await this.$store.dispatch('buttonsView/pushToViews', {deviceNumber: this.deviceNumber});
            await this.$store.dispatch('views/upload', {deviceNumber: this.deviceNumber});

            this.loading = false;
            this.isEditing = false;
        } catch (e) {
            this.loading = false;
        }
    }
    public async undoEdititing() {
        this.loading = true;
        await this.$store.dispatch('relaysView/load', { deviceNumber: this.deviceNumber });
        this.loading = false;
        this.isEditing = false;
    }

    public toggleVisibility(button: IButtonsButtonWithRelay) {
        if (this.buttonSetVisibility
            && this.deviceNumber) {
                const index = this.buttons.indexOf(button);
                this.buttonSetVisibility({
                    deviceNumber: this.deviceNumber,
                    index,
                    hidden: !button.button.hidden,
                });
            }
    }
    public moveUp(button: IButtonsButtonWithRelay) {
        if (this.buttonMoveUp
            && this.deviceNumber) {
                const index = this.buttons.indexOf(button);
                this.buttonMoveUp({
                    deviceNumber: this.deviceNumber,
                    index,
                });
            }
    }
    public moveDown(button: IButtonsButtonWithRelay) {
        if (this.buttonMoveDown
            && this.deviceNumber) {
                const index = this.buttons.indexOf(button);
                this.buttonMoveDown({
                    deviceNumber: this.deviceNumber,
                    index,
                });
            }
    }
    public setButtonName(button: IButtonsButtonWithRelay, event: any) {
        if (this.deviceNumber && this.relaysSetName) {
            const val = event.target.value;
            this.relaysSetName({
                deviceNumber: this.deviceNumber,
                relayNumber: button.relay.no,
                name: val,
            });
        }
    }
    public setButtonMode(button: IButtonsButtonWithRelay, event: any) {
        if (this.deviceNumber && this.relaysSetMode) {
            const val = event.target.value;
            this.relaysSetMode({
                deviceNumber: this.deviceNumber,
                relayNumber: button.relay.no,
                mode: val,
            });
        }
    }
    public setButtonIcon(button: IButtonsButtonWithRelay, newIcon: string) {
        if (this.deviceNumber && this.relaysSetIcon && button.relay.icon !== newIcon) {
            this.relaysSetIcon({
                deviceNumber: this.deviceNumber,
                relayNumber: button.relay.no,
                icon: newIcon,
            });
        }
    }


    public async created() {
        if (!this.verifyLoginStatus(true)) {
            return;
        }
        await this.loadPromises([
            {name: 'buttonsView/load', promise: () => this.$store.dispatch('buttonsView/load', { deviceNumber: this.deviceNumber })},
            {name: 'relaysView/load', promise: () => this.$store.dispatch('relaysView/load', { deviceNumber: this.deviceNumber })},
            {name: 'relays/load', promise: () => this.$store.dispatch('relays/load', { deviceNumber: this.deviceNumber })},
        ]);
        this.loading = false;
    }


}
